import { ACCESS_PROFILE, TABU_OWNER, UPDATE_PROFILE, UPDATE_PROFILE_PIC } from "./roles";
import { UserSource } from "./source";
import { BaseProfile, IProfile } from "./profiles";
import { getUser } from "./index";

export interface ITabuProfile extends IProfile {
	nameEn: string;
	nameAr: string;
	userName?: string;
	emailAddress: string;
	phoneNumber?: string;
	profileId: number;
	tabuParticipantId: number;
	profileTypeId: number;
	emiratesId: string;
	groupId: number;
	ssoUserId?: number;
	participantNumber?: number;
	isEmailVerified?: boolean;
}

export interface TabuVIPCategory {
	CategoryId: number;
	CategoryNameEn: string;
	CategoryNameAr: string;
	PropertyManagerNameEn: string;
	PropertyManagerNameAr: string;
	PropertyManagerMobile: string;
	PropertyManagerPhone: string;
	PropertyManagerEmail: string;
	participantNumber?: number;
}

export class TabuProfile extends BaseProfile implements ITabuProfile {
	emailAddress: string;
	emiratesId: string;
	groupId: number;
	nameAr: string;
	nameEn: string;
	phoneNumber?: string;
	profileId: number;
	profileTypeId: number;
	tabuParticipantId: number;
	ssoUserId?: number;
	participantNumber?: number;
	isEmailVerified?: boolean;

	constructor( profile: ITabuProfile ) {
		super( UserSource.TABU, profile.tabuParticipantId );
		this.refreshRoles();
		this.tabuParticipantId = profile.tabuParticipantId;
		this.emailAddress = profile.emailAddress;
		this.emiratesId = profile.emiratesId;
		this.groupId = profile.groupId;
		this.nameAr = profile.nameAr;
		this.nameEn = profile.nameEn;
		this.phoneNumber = profile.phoneNumber ? profile.phoneNumber.replace( /[^\d]/g, "" ) : undefined;
		this.profileId = profile.profileId;
		this.profileTypeId = profile.profileTypeId;
		this.ssoUserId = profile.ssoUserId;
		this.participantNumber = profile.participantNumber;
		this.isEmailVerified = profile.isEmailVerified;
	}

	static buildProfile( profile: ITabuProfile ): TabuProfile {
		const p = new TabuProfile( profile );
		return p;
	}

	static getProfile(): TabuProfile | undefined {
		const u = getUser();
		if ( u )
			return u.getProfile( UserSource.TABU ) as TabuProfile;
		return undefined;
	}

	static getParticipantId(): number | undefined {
		const p = TabuProfile.getProfile();
		if ( p ) return p.tabuParticipantId;
		return undefined;
	}

	static getEmiratesId(): string | undefined {
		const p = TabuProfile.getProfile();
		if ( p ) return p.emiratesId;
		return undefined;
	}

	static getParticipantNumber(): number | undefined {
		const p = TabuProfile.getProfile();
		if ( p ) return p.participantNumber;
		return undefined;
	}

	refreshRoles() {
		super.refreshRoles();
		if ( !this.hasRole( TABU_OWNER ) ) this.addRole( TABU_OWNER );
		if ( !this.hasRole( ACCESS_PROFILE ) ) this.addRole( ACCESS_PROFILE );
		if ( !this.hasRole( UPDATE_PROFILE ) ) this.addRole( UPDATE_PROFILE );
		if ( !this.hasRole( UPDATE_PROFILE_PIC ) ) this.addRole( UPDATE_PROFILE_PIC );
	}
}
